import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "half-date" }
const _hoisted_2 = { class: "half-date-value" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "icon-down" }, null, -1)
const _hoisted_4 = { class: "half-date-value" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "icon-down" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_picker = _resolveComponent("c-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_c_picker, {
      class: "half-date-picker",
      mode: "date",
      modelValue: _ctx.date,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["half-value-text", { 'c-palace': !_ctx.date }])
          }, _toDisplayString(_ctx.date || "请选择日期"), 3),
          _hoisted_3
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_c_picker, {
      class: "half-picker",
      range: _ctx.options,
      modelValue: _ctx.time,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.time) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["half-value-text", { 'c-palace': !_ctx.time }])
          }, _toDisplayString(_ctx.time || "请选择时间"), 3),
          _hoisted_5
        ])
      ]),
      _: 1
    }, 8, ["range", "modelValue"])
  ]))
}